/**
 * Studio mode tabs — AI Generate / Add Text.
 * Upload is no longer a peer tab; as-is lives on the Generate pane.
 */

/**
 * @param {HTMLElement} root
 * @param {{ setState: (patch: Record<string, unknown>) => void, getState: () => Record<string, unknown>, subscribe: (fn: (state: Record<string, unknown>) => void) => void }} store
 */
export function bindStudioModeTabs(root, store) {
    root.querySelectorAll('[data-bag-mode]').forEach((btn) => {
        btn.addEventListener('click', () => {
            if (btn.disabled) {
                return;
            }
            const mode = btn.getAttribute('data-bag-mode');
            if (mode !== 'generate' && mode !== 'text') {
                return;
            }
            store.setState({ studioMode: mode });
        });
    });

    store.subscribe((state) => {
        const allowed = ['generate', 'text'];
        const mode = allowed.includes(/** @type {string} */ (state.studioMode))
            ? state.studioMode
            : 'generate';
        root.querySelectorAll('[data-bag-mode]').forEach((btn) => {
            const isActive = btn.getAttribute('data-bag-mode') === mode;
            btn.classList.toggle('active', isActive);
            btn.setAttribute('aria-selected', isActive ? 'true' : 'false');
            if (btn instanceof HTMLButtonElement && !btn.hasAttribute('data-unavailable')) {
                const permanentlyOff = Boolean(btn.title) && btn.title.indexOf('unavailable') !== -1;
                if (!permanentlyOff) {
                    btn.disabled = Boolean(state.busy);
                }
            }
        });
        root.querySelectorAll('[data-bag-pane]').forEach((pane) => {
            pane.classList.toggle('d-none', pane.getAttribute('data-bag-pane') !== mode);
        });
    });
}
